import { Company, Execution, Person, WritSearchItem } from '@models/teranet';

export class SearchWrits {
	static readonly type = '[sale writ] search';
	constructor(public searches: WritSearchItem[]) {}
}

export class RemoveSearchItem {
	static readonly type = '[sale writ] remove search item';
	constructor(public index: number) {}
}

export class SearchCompanyItem {
	static readonly type = '[sale writ] search company';
	constructor(public payload: { writId: string; company: Company }) {}
}

export class SearchPersonItem {
	static readonly type = '[sale writ] search person';
	constructor(public payload: { writId: string; person: Person }) {}
}

export class SearchExecutionItem {
	static readonly type = '[sale writ] search execution';
	constructor(public payload: { writId: string; execution: Execution }) {}
}

export class PurchaseWrit {
	static readonly type = '[sale writ] purchase writ';
	constructor(public writId: string) {}
}

export class PurchaseExecution {
	static readonly type = '[sale writ] purchase execution';
	constructor(public payload: { writId: string; executionNumber: string }) {}
}

export class PurchaseExecutionSuccess {
	static readonly type = '[sale writ] purchase execution success';
	constructor(public executionNumber: string) {}
}

export class PurchaseExecutionFailure {
	static readonly type = '[sale writ] purchase execution failure';
	constructor(public payload: { executionNumber: string; error: string }) {}
}
